module.exports = __webpack_public_path__ + "static/media/2californiart43text.699afb1f.jpg";